import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AcceptTermsAndConditionResponse, ValidationTermsAndCondition, ValidationUserResponse } from '../../models/monex-ultra.model';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MonexUltra2Component } from '../../../components/monex-ultra/monex-ultra2.component';

@Injectable({
  providedIn: 'root'
})
export class MonexUltra2Service {
  apiUsers: string = "";
  private modalRef!: NgbModalRef;

  constructor(
    private http: HttpClient,
    private modalService: NgbModal,
    private modalConfig: NgbModalConfig
  ) {
    this.apiUsers = environment.apiUser;
  }

  validateUserContractPermission(contractId: string): Observable<ValidationUserResponse> {
    return this.http.get<ValidationUserResponse>(`${this.apiUsers}/ultra/valida/${contractId}`);
  }

  acceptTermsAndCondicions(body: any) : Observable<any>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    const payload ={
      jwt: body
    }
    return this.http.post<AcceptTermsAndConditionResponse>(`${this.apiUsers}/ultra/acepta/acuerdo`, payload, {headers});
  }

  validateUserAlreadyAcceptTC(body: any): Observable<ValidationTermsAndCondition> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    const payload ={
      jwt: body
    }
    return this.http.post<ValidationTermsAndCondition>(`${this.apiUsers}/ultra/valida/acuerdo`, payload, {headers});
  }

  openModal(referenceNumber: string, translations: any) {
    this.modalRef = this.modalService.open(MonexUltra2Component, { size: 'l' })
    this.modalRef.componentInstance.translations = translations;
    this.modalRef.componentInstance.modalRef = this.modalRef;
    this.modalRef.componentInstance.referenceNumber = referenceNumber;
  }
}
